class ShareButtons {
  public shareButtons: NodeListOf<HTMLElement>;

  openShareGroup(e: Event) {
    const target = e.currentTarget as HTMLElement;

    target.closest('.m-share-buttons')?.classList.add('is-active');
  }

  closeShareGroup(e: Event) {
    const target = e.target as HTMLElement;

    if (!target.classList.contains('a-wishlist-button')) {
      this.shareButtons?.forEach((element) => {
        element.classList.remove('is-active');
      });
    }
  }

  bindings() {
    this.closeShareGroup = this.closeShareGroup.bind(this);

    this.shareButtons?.forEach((element) => {
      element.querySelector('.a-wishlist-button')?.addEventListener('click', this.openShareGroup);
    });

    document.documentElement.addEventListener('click', this.closeShareGroup);
  }

  cache() {
    this.shareButtons = document.querySelectorAll('.m-share-buttons');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ShareButtons;
